import React from 'react'
import CashIcon from 'assets/images/funds/cashbox_4.png'
import { toast } from 'react-toastify'
import { StateConvertor } from 'utilities/helper/cashBoxes'

interface IItemProps {
    item: ICashBoxes
}

const StateChipStyle: {
    [key: string]: { bgColor: string; color: string }
} = {
    // پیش نویس → grey chip (gray_20 bg, gray_90 text)
    nct: { bgColor: '#DCE0E5', color: '#646E7A' },
    act: { bgColor: '#DCE0E5', color: '#646E7A' },
    dft: { bgColor: '#DCE0E5', color: '#646E7A' },
    // در انتظار قرعه‌کشی → blue chip (secondary_10 bg, secondary_alpha text)
    unp: { bgColor: '#E5F0F8', color: '#2FACFF' },
}

export default function Item({ item }: IItemProps) {
    const chipStyle = StateChipStyle[item.state] ?? {
        bgColor: '#DCE0E5',
        color: '#646E7A',
    }
    return (
        <div
            className="bg-white rounded-[10px] shadow-card my-[6px] cursor-pointer px-4 py-2.5"
            onClick={() => toast.error('این صفحه درحال پیاده سازی می باشد')}
        >
            {/* Header: avatar (end) + name/member (start) */}
            <div className="flex items-start gap-2">
                <div className="flex-1 min-w-0">
                    <p className="text-base font-bold text-black text-right truncate">
                        صندوق {item.name}
                    </p>
                    <p className="text-sm font-normal text-text-body text-right mt-1">
                        {item.period.valid_memberships_count} عضو، قرعه‌کشی
                    </p>
                </div>
                <img
                    src={CashIcon}
                    alt="fund-icon"
                    className="w-[60px] h-[60px] rounded-full border border-[#DCE0E5] object-cover p-[1px] shrink-0"
                />
            </div>

            {/* divider */}
            <div className="h-px bg-[#DCE0E5] mt-2.5" />

            {/* value rows — label (right) then value (left) for RTL */}
            <div>
                <div className="flex justify-between items-baseline mt-2.5">
                    <p className="text-sm font-normal text-text-secondary">
                        ارزش هر سهم
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {Number(item.period.share_value).toLocaleString()} تومان
                    </p>
                </div>
                <div className="flex justify-between items-baseline mt-1">
                    <p className="text-sm font-normal text-text-secondary">
                        سهم‌های فعلی
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {Number(item.period.total_shares).toLocaleString()} سهم
                    </p>
                </div>
                <div className="flex justify-between items-baseline mt-1">
                    <p className="text-sm font-normal text-text-secondary">
                        تعداد وام
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {item.period.number_of_loans} وام
                    </p>
                </div>
                <div className="flex justify-between items-baseline mt-1">
                    <p className="text-sm font-normal text-text-secondary">
                        تاریخ قرعه‌کشی
                    </p>
                    <p className="text-sm font-normal text-black text-left">
                        {item.period.day_of_draw.toLocaleString()} ام هر ماه
                    </p>
                </div>
            </div>

            {/* divider */}
            <div className="h-px bg-[#DCE0E5] mt-2.5" />

            {/* status */}
            <p className="text-sm font-normal text-text-secondary text-right mt-2.5">
                وضعیت
            </p>
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center gap-1.5">
                    <span className="w-1 h-1 rounded-full bg-text-secondary" />
                    <p className="text-sm font-normal text-text-secondary">
                        حالت صندوق
                    </p>
                </div>
                <div
                    className="inline-flex items-center rounded-[6px] pl-2.5 pr-2.5 pt-0.5 pb-1"
                    style={{ backgroundColor: chipStyle.bgColor }}
                >
                    <p
                        className="text-xs font-bold"
                        style={{ color: chipStyle.color }}
                    >
                        {StateConvertor[item.state]}
                    </p>
                </div>
            </div>
        </div>
    )
}
